import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PetlingsLogo } from '../components/icons';
import api from '../api/client';

/**
 * OAuth callback handler.
 * Microsoft redirects here with ?code=... after the user signs in.
 * We send the code to our backend which exchanges it for a Petlings JWT.
 */
export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState('');
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const code = searchParams.get('code');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError(`Microsoft sign-in was cancelled or failed: ${searchParams.get('error_description') || errorParam}`);
      setProcessing(false);
      return;
    }

    if (!code) {
      setError('No authorization code received from Microsoft.');
      setProcessing(false);
      return;
    }

    // Send code to our backend
    api.post('/auth/microsoft', {
      code,
      redirect_uri: window.location.origin + '/auth/callback',
    })
      .then((res) => {
        const { access_token, user } = res.data;
        // Use loginWithToken to store the JWT
        loginWithToken(access_token, user).then(() => {
          navigate('/pets', { replace: true });
        });
      })
      .catch((err) => {
        const detail = err.response?.data?.detail || 'Authentication failed. Make sure you own Minecraft Java Edition.';
        setError(detail);
        setProcessing(false);
      });
  }, [searchParams, loginWithToken, navigate]);

  if (processing) {
    return (
      <div className="login-page">
        <div className="login-card card" style={{ textAlign: 'center', padding: '40px' }}>
          <PetlingsLogo size={48} color="var(--green-primary)" />
          <h2 style={{ marginTop: '16px' }}>Signing you in...</h2>
          <p style={{ color: 'var(--text-secondary)', marginTop: '8px' }}>
            Verifying your Microsoft account with Minecraft.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card card" style={{ textAlign: 'center', padding: '40px' }}>
        <PetlingsLogo size={48} color="var(--orange-primary)" />
        <h2 style={{ marginTop: '16px' }}>Sign-in Failed</h2>
        <p style={{ color: 'var(--text-secondary)', marginTop: '8px', marginBottom: '20px' }}>{error}</p>
        <button className="btn btn-primary" onClick={() => navigate('/login')}>
          Try Again
        </button>
      </div>
    </div>
  );
}
